import React, { useState, useRef, useEffect } from "react";

const HighSpeedDataType = ({ getString, field, value,handleFocusNext,inputRefs,indext,config,ref,nextIndex }) => {
    const [qrCodeResult, setQrCodeResult] = useState(value);
    const [isStart, setIsTart] = useState(false);

    const lastInputTimeRef = useRef(0);
    // lastInputTimeRef.current = new Date().getTime();
    // const inputRef = useRef()
    useEffect(() => {
        getString(qrCodeResult)
    }, [qrCodeResult])

    useEffect(() => {
        setQrCodeResult(value)
    }, [value])

    const startInput = (event) => {
        // const currentTime = event.timeStamp;
        // lastInputTimeRef.current = new Date().getTime();
        // const timeDiff = currentTime - lastInputTimeRef.current;
        // lastInputTimeRef.current = currentTime;

        // if (timeDiff < 50) {
        //     setQrCodeResult(event.target.value); // Accept input from the QR code reader
        // } 


    }

    const handleInput = (event) => {
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - lastInputTimeRef.current;
       
        if (!qrCodeResult) {
            event.preventDefault()
            lastInputTimeRef.current = new Date().getTime();
            setQrCodeResult(event.target.value);
        } else if (timeDiff < 50) {
            lastInputTimeRef.current = new Date().getTime();
            setQrCodeResult(event.target.value);
        } else {
        }
    };

    const handleKeyDown = (e) => {
        e.preventDefault()
    };

    return (
        <div className='col-sm-4 mt-4'>
            <div className="row">
                <div className="col pr-0">
                    <div className="form-group ">
                        <label className='small d-flex mb-0'>{field.FieldName}{field.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                        <input
                            // ref={inputRef}
                            ref={(el) => (inputRefs.current[`0-${indext}-high_speed_string`] = el)}  // Store ref
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                const isLastField = indext === config.CustomFields.length - 1;
        
                                // Find the next non-select input field
                                let nextIndex = indext + 1;
                                while (nextIndex < config.CustomFields.length && config.CustomFields[nextIndex].DataType === 'list') {
                                  nextIndex++; // Skip the select fields
                                }
        
                                if (isLastField && config.SampleSerial === "Manual" && handleFocusNext) {
                                  handleFocusNext(`${0}Parent`);  // Move to the parent if last field
                                } else if (isLastField && handleFocusNext) {
                                  // Move focus to the first input of the next section (e.g., `1-0`)
                                  handleFocusNext(`0-0`);
                                console.log(config.CustomFields[indext].DataType,"cjvcjhcvj")

                                }
                                else if(field.DataType ==='high_speed_string'){
                                console.log(config.CustomFields[indext].DataType,"cjvcjhcvj")
                                const next =config.CustomFields[nextIndex] && config.CustomFields[nextIndex].DataType ? config.CustomFields[nextIndex].DataType :null
                               console.log(next,"bidbndinb")
                                if(next ==null || next ==='string' ){

                                    handleFocusNext && handleFocusNext(`0-0`);
                                }else if ( next ==='text' ){
                                    
                                    handleFocusNext && handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType}`);

                                }
                                else if ( next ==='float'){
                                    
                                    handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType}`);

                                }

                                } else if (nextIndex < config.CustomFields.length) {
                                console.log(config.CustomFields[indext].DataType,"cjvcjhcvj")

                                  // Focus on the next input field (skipping select)
                                  handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType === 'float' ? 'float' : 'text'}`);
                                }
                              }
                            }}
                            className='form-control form-control-sm'
                            type="text"
                            value={qrCodeResult ? qrCodeResult : ""}
                            onInput={handleInput} // Detect rapid input for QR code
                           // onKeyDown={handleKeyDown} // Prevent manual typing
                            placeholder={field.FieldName +" here..."}
                        />
                    </div>
                </div>
                <div className="col mt-4 pl-0">
                    <button onClick={() => setQrCodeResult("")} className="btn btn-sm btn-danger">Clear</button>
                </div>
            </div>

        </div>
    );
};

export default HighSpeedDataType;
